// src/subscreens/Auth/AdminLogin.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaGraduationCap,
  FaEye,
  FaEyeSlash,
  FaEnvelope,
  FaLock,
} from "react-icons/fa";
import "../../../assets/css/admin/auth/AdminLogin.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "./../../../context/AppContext";

const AdminLogin = () => {
  const { baseUrl, storeLoggedInAdmin, regExpChecker } = useContext(AppContext);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const navigate = useNavigate();

  const adminLogin = () => {
    // Validation
    const emailErr = regExpChecker("email", email);
    const passErr = regExpChecker("password", password);

    if (emailErr) {
      setEmailError("Invalid email format. Please write in this format: example@gmail.com");
    } else {
      setEmailError("");
    }

    if (passErr) {
      setPasswordError(
        "Password must be at least 6 characters, contain a number and a letter. Example: Abc123"
      );
    } else {
      setPasswordError("");
    }

    if (emailErr || passErr) return;

    // Login request
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/adminlogin`, formData, {
        headers: { "Content-Type": "multipart-formdata" },
      })
      .then((response) => {
        if (response.data.success) {
          localStorage.setItem("adminEmail", email);
          localStorage.setItem("adminPassword", password);
          localStorage.setItem("admin", JSON.stringify(response.data.admin));
          storeLoggedInAdmin(response.data.admin);
          navigate("/admin/dashboard");
        } else {
          Swal.fire("Oops!", "Your credentials are not correct.", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const adminAutoLogin = (em, pw) => {
    const formData = new FormData();
    formData.append("email", em);
    formData.append("password", pw);

    axios
      .post(`${baseUrl}/admin/auth/adminlogin`, formData, {
        headers: { "Content-Type": "multipart-formdata" },
      })
      .then((response) => {
        if (response.data.success) {
          storeLoggedInAdmin(response.data.admin);
          localStorage.setItem("admin", JSON.stringify(response.data.admin));
          navigate("/admin/dashboard");
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    let storedEmail = localStorage.getItem("adminEmail");
    let storedPassword = localStorage.getItem("adminPassword");

    if (storedEmail && storedPassword) {
      adminAutoLogin(storedEmail, storedPassword);
    }
  }, []);

  return (
    <div className="ap-auth-page">
      <div className="ap-auth-background"></div>

      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-10 col-xl-9">
            <div className="ap-auth-card">
              <div className="row g-0">
                {/* LEFT BRANDING */}
                <div className="col-lg-5 d-none d-lg-block">
                  <div className="ap-auth-branding">
                    <div className="ap-branding-content">
                      <div className="ap-brand-logo">
                        <FaGraduationCap size={60} />
                        <h2>CircleHub</h2>
                      </div>
                      <h3 className="ap-tagline">Learn Better, Together</h3>
                      <p className="ap-brand-description">
                        AI-powered learning & collaborative study platform.
                      </p>
                    </div>
                  </div>
                </div>

                {/* RIGHT FORM */}
                <div className="col-lg-7">
                  <div className="ap-auth-form-container">
                    <form className="ap-auth-form">
                      <h3 className="ap-form-title">Welcome Back</h3>

                      {/* EMAIL */}
                      <div className="ap-form-group">
                        <label>Email</label>
                        <div className="ap-input-wrapper">
                          <FaEnvelope className="ap-input-icon" />
                          <input
                            type="email"
                            className="ap-form-control"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        {emailError && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {emailError}
                          </div>
                        )}
                      </div>

                      {/* PASSWORD */}
                      <div className="ap-form-group">
                        <label>Password</label>
                        <div className="ap-input-wrapper">
                          <FaLock className="ap-input-icon" />
                          <input
                            type={showPassword ? "text" : "password"}
                            className="ap-form-control"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <button
                            type="button"
                            className="ap-password-toggle"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                        {passwordError && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {passwordError}
                          </div>
                        )}
                      </div>

                      {/* LOGIN BUTTON */}
                      <button
                        type="button"
                        className="ap-btn-auth"
                        onClick={adminLogin}
                      >
                        Login
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;